export default {"src":"/_next/static/media/thumbnail.3029025d.svg","height":512,"width":1037,"blurWidth":0,"blurHeight":0};